<div [ngClass]="['bento-card', className]">
  <img [src]="image" [alt]="name" class="background-image" loading="lazy" />
  <div class="screen"></div>
  <div class="scanline"></div>

  <div class="content">
    <div class="topline">
      <div class="icon-wrap" [ngSwitch]="icon" aria-hidden="true">
        <svg *ngSwitchCase="'file'" viewBox="0 0 24 24" class="icon"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6"/></svg>
        <svg *ngSwitchCase="'search'" viewBox="0 0 24 24" class="icon"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
        <svg *ngSwitchCase="'globe'" viewBox="0 0 24 24" class="icon"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
        <svg *ngSwitchCase="'calendar'" viewBox="0 0 24 24" class="icon"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
        <svg *ngSwitchCase="'bell'" viewBox="0 0 24 24" class="icon"><path d="M10 5a2 2 0 0 1 4 0c0 2.5.5 4 1.4 5.4.8 1.2 1.6 2.1 1.6 3.6H7c0-1.5.8-2.4 1.6-3.6C9.5 9 10 7.5 10 5z"/><path d="M9 18a3 3 0 0 0 6 0"/></svg>
      </div>

      <p class="metric" *ngIf="metric">{{ metric }}</p>
    </div>

    <h3>{{ name }}</h3>
    <p>{{ description }}</p>
  </div>

  <div class="footer">
    <p class="helper" *ngIf="helperText">{{ helperText }}</p>

    <app-ui-button variant="ghost" size="sm" [href]="href">
      {{ cta }}
      <span aria-hidden="true">→</span>
    </app-ui-button>
  </div>
</div>
